/* eslint-disable @typescript-eslint/no-empty-function */
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { appRoutes } from './app.routes';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { refreshTokenInterceptor } from './shared/interceptors/refresh-token.interceptor';
import { headerInterceptor } from './shared/interceptors/header.interceptor';
import { FormlyFieldTypeahead } from './shared/formly/typeahead.type.component';
import { FormlyFieldRecordAudio } from './shared/formly/record-audio.type.component';
import { FormlyFieldMultiSelect } from './shared/formly/multiselect.type.component';

import * as Sentry from '@sentry/angular';

export function EmailValidator(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
  return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(control.value) ? null : { email: true };
}

export function EmailValidatorMessage(err: any, field: FormlyFieldConfig) {
  return `Not a valid Email Address`;
}

export function showErrorOption(field: any) {
  return field.formState.submitted && !field.formControl.valid;
}

export function fieldMatchValidator(control: AbstractControl) {
  const { password, passwordConfirm } = control.value;

  // avoid displaying the message error when values are empty
  if (!passwordConfirm || !password) {
    return null;
  }

  if (passwordConfirm === password) {
    return null;
  }

  return { fieldMatch: { message: 'Password Not Matching' } };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    importProvidersFrom(
      FormlyModule.forRoot({
        extras: { showError: showErrorOption },
        types: [
          { name: 'typeahead', component: FormlyFieldTypeahead },
          { name: 'record-audio', component: FormlyFieldRecordAudio },
          { name: 'multiselect', component: FormlyFieldMultiSelect },
        ],
        validators: [
          { name: 'email', validation: EmailValidator },
          { name: 'fieldMatch', validation: fieldMatchValidator },
        ],
        validationMessages: [
          { name: 'required', message: 'This field is required' },
          { name: 'email', message: EmailValidatorMessage },
        ],
      }),
    ),
    provideAnimations(),
    provideHttpClient(withInterceptors([headerInterceptor]), withInterceptorsFromDi()),
    provideToastr({ positionClass: 'toast-top-center', maxOpened: 1 }),
    refreshTokenInterceptor,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
